import { Unit } from './unit.model';

export interface UnitSystem {
  id: string;
  text: string;
  units: Unit[];
}
